<div class="wa-stack" [formGroup]="surveyProperties">
  <wa-input type="text" formControlName="name" placeholder="Name" label="name"></wa-input>
  <div class="wa-grid">
    <wa-date-input formControlName="begin" label="voting starts on"></wa-date-input>
    <wa-date-input formControlName="end" label="voting ends on"></wa-date-input>
  </div>
</div>
